
function UnitScanMbus() {
    /// <summary>
    /// This object provides js functions for VC.Widget.Unit.Scans <br/>
    ///TODO: documentation






    /// <br/>
    /// Author: ARF<br />
    /// Date: 5.11.2018<br />
    /// Copyright ©: EUDT GmbH 2018 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 5.11.2018                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.meters= null;
}

UnitScanMbus.prototype = new vcTemplate();

UnitScanMbus.prototype.init = function () {
    var me = this;
    /// <summary>
    /// This function inits the click handler, events and other initial stuff. 
    /// </summary>

    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);

        //init new scan button
        me.visual.find("#div-btn-new-scan").off("click").on("click", function () { alert("start new scan"); }).button();
        me.visual.find("#div-btn-save").off("click").on("click", function () { alert("save signal"); });
      
        me.visual.find("#vc-list-scan .vc-list-item:even").addClass("alt");



        me.visual.find("#div-list-scan .vc-list-table").off("click", ".vc-list-item").on("click", ".vc-list-item", function(e) {
            me.fetchMeters($(e.target));
        });
        me.visual.find("#vc-list-meter").off("click", ".vc-list-item").on("click", ".vc-list-item", function (e) {
            me.fetchRegisters($(e.target));
        });
    return true;
    } catch (ex) { me.writeError('init', ex); return false }

}




UnitScanMbus.prototype.fetchMeters = function (obj) {
    /// <summary>
    /// This function fetches  <br/>
    /// </summary>
    var me = this;
    var ciid;
    var oid;
    var param;
    var meters = [];
    var lst = [];
    var primAddr = -1;
    var secAddr = -1;
    var importObj;
    var stmp;
    try {
        if (me.error) { return false; }
        if (obj.hasClass("vc-list-item") === false) {
            obj = obj.parents(".vc-list-item");
        }
        
        ciid = parseInt(obj.data("id"), 10);

        //me.toggleWaiting(true, 0);



        //me.toggleCopyMenu(true);

        //me.visual.find("#signal-table").html("").hide();


        param = { "type": 0, "ciid": ciid }

        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(param),
        function (result) {
            if (result === null) { me.showMessage(me.resources.err_loadData, true); return true; }

            me.meters = null;
            
            if (result.length === 0) {
                me.visual.find("#vc-list-meter").html($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return true;
            }

            me.meters = result;
            meters = new Array(me.meters.length);
            me.visual.find("#vc-list-meter").html("");
            for (var i = 0; i < me.meters.length; i++) {
 
            if ((me.meters[i].Addresses[0].Addr + "/" + me.meters[i].Addresses[0].Funcreg) !== (primAddr + "/" + secAddr)) {
                primAddr = me.meters[i].Addresses[0].Addr;
                if (primAddr === null) { primAddr = 0 }
                secAddr = me.meters[i].Addresses[0].Funcreg;
                if (secAddr === null) { secAddr = 0 }
                    oid = (primAddr + "/" + secAddr);

                    meters[i] = $("<div>").addClass("vc-list-item");
                    meters[i].data("addr", oid);


                    console.info(meters[i].data("addr"));

                    if (me.meters[i].Import !== null) {
                        importObj = JSON.parse(me.meters[i].Import);
                        stmp = importObj.Manufacturer + ' - ';
                    } else {
                        stmp = "";
                    }
                    meters[i].append($("<span>").addClass("main").html(stmp + "addr: " + oid));
                    meters[i].append("<br/>");
                    lst.push(meters[i]);
                }
            }
            me.visual.find("#vc-list-meter").append(lst);

            me.visual.find("#vc-list-meter .vc-list-item:even").addClass("alt");


            result = null;

            return true;
        });

        return true;
    } catch (ex) {
        me.writeError('fetchMeters', ex);
        return false;
    }

};



UnitScanMbus.prototype.fetchRegisters = function (obj) {
    /// <summary>
    /// This function fetches  <br/>
    /// </summary>
    var me = this;
 
    var registers;
    var lst = [];
    var addr;
    var primAddr = -1;
    var secAddr = -1;
    var importObj;
    var bdimsid;
    var col;
    try {
        if (me.error) { return false; }
        if (obj.hasClass("vc-list-item") === false) {
            obj = obj.parents(".vc-list-item");
        }

        addr = obj.data("addr");
        console.info(addr);
        registers = new Array(me.meters.length);
        me.visual.find("#vc-list-register").html("");
        for (var i = 0; i < me.meters.length; i++) {
           
            if ((me.meters[i].Addresses[0].Addr + "/" + me.meters[i].Addresses[0].Funcreg) !== addr) {
                primAddr = me.meters[i].Addresses[0].Addr;
                if (primAddr === null) { primAddr = 0 }
                secAddr = me.meters[i].Addresses[0].Funcreg;
                if (secAddr === null) { secAddr = 0 }
                addr = (primAddr + "/" + secAddr);

                if (me.meters[i].Import !== null) {
                    importObj = JSON.parse(me.meters[i].Import);
                   
                } else {
                    importObj = null;
                }

                console.info(me.meters[i]);
                if (importObj.Unit !== null) {
                    bdimsid = me.matchDims(importObj.Unit);
                    bdimsid = me.matchDims("kwh");
                } else {
                    bdimsid = -1;
                }
                if (bdimsid > -1) {
                    me.meters[i].Addresses[0].Bdimsid = bdimsid;
                    me.meters[i].Info.Bdimsid = bdimsid;
                    bdimsid = $("<span>").html(" (bdimsid: " + bdimsid + ")");
                } else {
                    bdimsid = $("<span>").addClass("error").html("No unit match found!");
                }

                registers[i] = $("<div>").addClass("vc-list-item");
                col = $("<div>").addClass("vc-list-col");
                col.append($("<div>").addClass("vc-list-col-element col0").append(me.meters[i].Addresses[0].Reg));
                col.append($("<div>").addClass("vc-list-col-element col1").append(me.meters[i].Addresses[0].Len));
                col.append($("<div>").addClass("vc-list-col-element col2").append(importObj.Unit ).append(bdimsid));
                col.append($("<div>").addClass("vc-list-col-element col3").append(importObj.Value));
                col.append($("<div>").addClass("vc-list-col-element col4").append($("<input>").prop("type", "checkbox").addClass("ckh-archive")));
                col.append($("<div>").addClass("vc-list-col-element col5").append($("<input>").prop("type", "checkbox").addClass("ckh-online")));
               
                registers[i].append(col);
                
                lst.push(registers[i]);
            }
        }
        me.visual.find("#vc-list-register").append(lst);

        me.visual.find("#vc-list-register .vc-list-item:even").addClass("alt");

        return true;

    } catch (ex) {
        me.writeError('fetchRegisters', ex);
        return false;
    }

};



UnitScanMbus.prototype.matchDims = function (unit) {
    /// <summary>
    /// This function fetches  <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        unit = unit.toLowerCase();
        for (var i = 0; i < me.lstDims.length - 1; i++) {
            if (me.lstDims[i].name.toLowerCase() === unit) {
                return me.lstDims[i].id;
            }
        }
        return -1;
    } catch (ex) {
        me.writeError('matchDims', ex);
        return -1;
    }

};


















UnitScanMbus.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
      
       
        if (bError) {me.visual.find(".vc-list, #div-state, #div-btn-refresh,#div-btn-add, .select-view, #div-unit-viewer, #div-btn-import").hide();}
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


UnitScanMbus.prototype.writeError = function (source, ex) {
    var me = this;
    try {
        console.info(source + ':' + ex);
        me.error = true;
        me.showMessage(me.resources.err_code, true);
        writeError(me.source + ".JS." + source, ex);
        return false;
    } catch (ex) {
        me.error = true;
        writeError(me.source + '.JS.writeError', ex);
        return false;
    }
};